import { SegHeaderLogo } from "../../Components/SegUI/SegHeaderLogo/SegHeaderLogo";
import { AvisosEmbudo } from "../../Components/Slides/Auto/Emision/AvisosEmbudo";
import segurarse from "../../Assets/img/logo_segurarse.svg";
import afip from "../../Assets/img/DATAWEB.jpg";
import "@splidejs/react-splide/css";
import { SegSvg } from "../../Components/SegUI/SegSvg/SegSvg";
import { useEffect, useMemo, useRef, useState } from "react";
import { ModalPrecios } from "../../Components/Slides/Auto/Precios/ModalPrecios";
import { useNavigate, useParams } from "react-router-dom";
import { useCotizacionStore } from "../../Services/Providers/CotizacionStore";
import cotizar from "../../Services/API/Cotizar";
import { Slider } from "../../Components/Slides/Auto/Precios/Slider";
import { Grilla } from "../../Components/Slides/Auto/Precios/Grilla";
import guardarContacto from "../../Services/API/GuardarContacto";
import { SegLoading } from "../../Components/SegUI/SegLoading/SegLoading";
import { Cards } from "../../Components/Slides/Auto/Precios/Cards";
import { GraciasAuto } from "../Gracias/GraciasAuto";
import axios from "axios";
import { useDescripcionesStore } from "../../Services/Providers/DescripcionesStore";
import { useEmisionStore } from "../../Services/Providers/EmisionStore";
import useSEOConfig from "../../hooks/seo/useSEOConfig";
import { useConfiguracionEmpresa } from "../../Services/Providers/useConfiguracionEmpresa";
import { useConfig } from "../../context/ConfigContext";
import { autoViaBffDesdeConfig } from "../../Services/API/bff/auto/flag";
import { crearContacto } from "../../Services/API/bff/auto/funnel";
import {
    escucharPrecios,
    cargarSnapshotPrecios,
    ContextoPrecios,
} from "../../Services/API/bff/auto/preciosBff";
import { aBffError } from "../../Services/API/bff/auto/bffError";
import {
    armarContextoPrecios,
    logoDeCompania,
    resumenDeCoberturas,
} from "../../Services/API/bff/auto/contextoPrecios";
import {
    mensajeDeError,
    requiereVolverADatos,
} from "../../Services/API/bff/auto/errorMessages";
import { getPasoDatos } from "../../utils/getRubro";
import { useRegistroVendedor } from "../../Services/ventaPresencial/useRegistroVendedor";
import { inicioCotizacion } from "../../Services/ventaPresencial/rutaVendedor";

export interface Cotizacion {
    PrecioSinDescuento: string;
    DescuentoPorcentaje: number;
    id: null | string;
    nroCotizacion: string;
    codigoCobertura: string;
    descripcionCobertura: string;
    descripcionCoberturaOriginal: string;
    descripciones: Descripcion[];
    nombreCobertura: string;
    prima: number;
    columna: string;
    franquicia: string;
    premio: string;
    Parametros: string;
    SumaAsegurada: string;
    DescResumen: string[];
    LogoCompania: string;
    NombreCompania: string;
    CodigoCompania?: string;
    Mostrar: boolean;
    Afip: string;
    EmisionHabilitada: boolean;
    esPrecioPromocional?: boolean;
}

interface Descripcion {
    Nombre: string;
    Descripcion: string;
    Aclaracion: null | string;
}

export interface CotizacionDesc {
    id: string;
    planName: string;
    discountAmount: string;
    discountPerc: string;
    amountMonth: string;
    descList: any[];
    companyLogo: string;
    companyName: string;
    codCompany?: string;
    fiscalInfoImg: string;
    sumaAsegurada: string;
}

export const Precios = () => {
    const { emisionValues, setEmisionValues } = useEmisionStore();
    const { config, origen } = useConfiguracionEmpresa();
    const {
        cotizacionValues,
        setCotizacionValues,
        vaciarCotizaciones,
    } = useCotizacionStore();
    const { descripcionesValues } = useDescripcionesStore();
    const [cotizando, setCotizando] = useState<boolean>(false);
    const [cargando, setCargando] = useState<boolean>(false);
    const { compania } = useParams();
    const nav = useNavigate();
    const { config: envConf, isLoading: configCargando } = useConfig()

    const [isCollapsed, setCollapsed] = useState(true);

    /** Camino nuevo: precios por una sola conexión SSE contra el BFF. */
    const viaBff = autoViaBffDesdeConfig(envConf);
    const conexionSse = useRef<{ cancelar: () => void } | null>(null);

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const handleScroll = () => {
        // Aquí puedes añadir lógica para determinar si el componente está abierto
        // y luego colapsarlo si es necesario
        if (!isCollapsed) {
            // Lógica para colapsar el componente
            setCollapsed(true);
        }
    };

    const handleSetCotizacionDesc = (cotizacion: CotizacionDesc) => {
        setEmisionValues({
            ...emisionValues,
            cotizacionDesc: cotizacion,
        });
    };

    useSEOConfig({
        title: "Auto",
        marcaBlanca: (config.origen !== "" && config.origen !== "SEGURARSE") ? config.origen.charAt(0).toUpperCase() +
            config.origen.slice(1).toLowerCase() : undefined
    })

    useEffect(() => {
        // Añade el event listener al objeto window
        window.addEventListener("scroll", handleScroll);
        // Limpia el event listener al desmontar el componente
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isCollapsed]);

    const toggleCollapse = () => {
        // Invierte el estado de colapsado al hacer clic en el enlace
        setCollapsed(!isCollapsed);
    };

    const ajustarDescripciones = async (coti: any) => {
        try {
            let descripciones: Descripcion[] = [];
            const descripcionesGuardadas = descripcionesValues;
            (Object.keys(
                descripcionesGuardadas
            ) as (keyof typeof descripcionesGuardadas)[]).forEach((key, index) => {
                const desc = descripcionesGuardadas[index];
                if (
                    //desc.CompaniaDescripcion.replace(/\s+/g, '').toLowerCase() === coti.NombreCompania.replace(/\s+/g, '').toLowerCase() &&
                    desc.CompaniaDescripcion === coti.NombreCompania &&
                    desc.CodigoCompania === coti.codigoCobertura
                ) {
                    let texto;
                    if (desc.Texto === "si") {
                        texto = "Si";
                    } else if (desc.Texto === "no") {
                        texto = "No";
                    } else {
                        texto = desc.Texto;
                    }
                    let nuevaDesc: Descripcion = {
                        Nombre: desc.ItemDescripcion2Nombre,
                        Aclaracion: desc.Aclaraciones,
                        Descripcion: texto,
                    };
                    descripciones.push(nuevaDesc);
                }
            });
            return descripciones;
        } catch (error) { }
    };

    /** Los cinco textos cortos de la card (compartido con /retomar). */
    const descripcionesResumen = (descripciones: any[]) =>
        resumenDeCoberturas(descripciones, envConf.pais);

    // const descripcionesResumen = (descripciones: any[]) => {
    //     var textosCortos = [
    //         descripciones.find((desc: any) => desc.Nombre === "Cristales Laterales") ? (descripciones.find((desc: any) => desc.Nombre === "Cristales Laterales").Descripcion ? descripciones.find((desc: any) => desc.Nombre === "Cristales Laterales").Descripcion : "No") : "No",
    //         descripciones.find((desc: any) => desc.Nombre === "Reposición a 0km") ? (descripciones.find((desc: any) => desc.Nombre === "Reposición a 0km").Descripcion ? descripciones.find((desc: any) => desc.Nombre === "Reposición a 0km").Descripcion : "No") : "No",
    //         descripciones.find((desc: any) => desc.Nombre === "Cobertura en Exterior") ? (descripciones.find((desc: any) => desc.Nombre === "Cobertura en Exterior").Descripcion ? descripciones.find((desc: any) => desc.Nombre === "Cobertura en Exterior").Descripcion : "No") : "No",
    //         descripciones.find((desc: any) => desc.Nombre === "Auxilio Mecánico y Remolque") ? (descripciones.find((desc: any) => desc.Nombre === "Auxilio Mecánico y Remolque").Descripcion ? descripciones.find((desc: any) => desc.Nombre === "Auxilio Mecánico y Remolque").Descripcion : "No") : "No",
    //         descripciones.find((desc: any) => desc.Nombre === "Granizo") ? (descripciones.find((desc: any) => desc.Nombre === "Granizo").Descripcion ? descripciones.find((desc: any) => desc.Nombre === "Granizo").Descripcion : "No") : "No",
    //     ]
    //     return textosCortos;
    // }

    const descripcionCobertura = (columna: string) => {

        switch (envConf.pais) {
            case "AR": {
                switch (columna) {
                    case "A":
                        return "Responsabilidad Civil";
                    case "B":
                        return "Terceros Completo";
                    case "C":
                        return "Terceros Completo Full";
                    case "D":
                    case "E":
                        return "Todo Riesgo";
                    default:
                        return "";
                }
            }
            case "UY": {
                switch (columna) {
                    case "A":
                        return "Cobertura SOA";
                    case "B":
                        return "Responsabilidad Civil";
                    case "C":
                    case "D":
                        return "Triple";
                    case "E":
                    case "F":
                        return "Totales";
                    default:
                        return "";
                }
            }
            default: return ""
        }
    };

    const cotizarInterno = async (compania: any, indexCompania: number) => {
        let nuevoArray: Cotizacion[] = [];
        try {
            const response: any = await cotizar(
                compania.codigoCompania,
                cotizacionValues.contactoId!,
                compania.emisionOnlineHabilitada,
                cotizacionValues.token!,
                source
            );
            if (response.data.api_status) {
                if (
                    response.data.api_status === 200 &&
                    response.data.api_data !== null
                ) {
                    if (response.data.api_data.items.length > 0) {
                        for (
                            let index = 0;
                            index < response.data.api_data.items.length;
                            index++
                        ) {
                            let cotiNueva = response.data.api_data.items[index];
                            let auxPrecio: number = Number.parseInt(cotiNueva.premio);
                            let auxSuma: number = cotiNueva.SumaAsegurada
                                ? Number.parseInt(cotiNueva.SumaAsegurada.toString())
                                : Number.parseInt(
                                    response.data.api_data.sumaAsegurada.toString()
                                );
                            cotiNueva.DescuentoPorcentaje = 30;
                            cotiNueva.PrecioSinDescuento = (auxPrecio * 1.2).toLocaleString(
                                "es-AR"
                            );
                            cotiNueva.LogoCompania = encontrarRuta(compania.codigoCompania);
                            cotiNueva.NombreCompania = compania.nombreCompania;
                            cotiNueva.CodigoCompania = compania.codigoCompania;
                            cotiNueva.Mostrar = true;
                            cotiNueva.Afip = afip;
                            cotiNueva.premio = auxPrecio.toLocaleString("es-AR");
                            cotiNueva.SumaAsegurada = auxSuma
                                ? auxSuma.toLocaleString("es-AR")
                                : "";
                            cotiNueva.nombreCobertura = descripcionCobertura(
                                cotiNueva.columna
                            );
                            cotiNueva.descripciones = await ajustarDescripciones(cotiNueva);
                            cotiNueva.DescResumen = descripcionesResumen(
                                cotiNueva.descripciones
                            );
                            //cotiNueva.columna = cotiNueva.columna === "E" ? "D" : cotiNueva.columna;

                            cotiNueva.EmisionHabilitada = compania.emisionOnlineHabilitada;
                            if (cotiNueva.descripciones.length > 0) {
                                nuevoArray.push(cotiNueva);
                            }
                            if (index === response.data.api_data.items.length - 1) {
                                if (nuevoArray.length > 0) {
                                    return nuevoArray;
                                } else {
                                    return [];
                                }
                            }
                        }
                    }
                }
                return [];
            }
        } catch (error) { }
        return [];
    };

    /** Rubro del flujo, en el formato que espera la capa del BFF. */
    const ramoBff = "auto" as const;

    /** Contexto que el adaptador de precios necesita de esta pantalla. */
    const contextoPrecios = (): ContextoPrecios =>
        armarContextoPrecios({
            companias: cotizacionValues.parametrosIniciales?.companias,
            descripciones: descripcionesValues as any,
            pais: envConf.pais,
            sumaAseguradaIA: cotizacionValues.sumaAseguradaIA,
        });

    /** Manda a rehacer el paso de datos con el aviso correspondiente. */
    const volverADatos = (mensaje: string) => {
        nav(`${getPasoDatos("auto", compania)}?error=${encodeURIComponent(mensaje)}`);
    };

    /**
     * Camino BFF: crea el lead y guarda el JWT de cotización. El recaptcha se
     * mintea fresco adentro de `crearContacto` (acción `contacto`).
     */
    const crearContactoBff = async () => {
        try {
            await crearContacto(ramoBff, cotizacionValues);
        } catch (error) {
            const bffError = aBffError(error);
            if (bffError.code === "blocked") {
                const props = {
                    nombre: cotizacionValues.nombre + " " + cotizacionValues.apellido,
                    email: cotizacionValues.email!,
                    telefono:
                        cotizacionValues.telefono?.prefijo +
                        "" +
                        cotizacionValues.telefono?.numero,
                    vehiculo:
                        cotizacionValues.marca?.value +
                        " " +
                        cotizacionValues.version?.value +
                        " " +
                        cotizacionValues.año?.value,
                    aseguradora: "Sin seleccionar",
                    tipo: "emision",
                };
                return compania
                    ? nav("/auto/gracias-alt/" + compania, { state: props })
                    : nav("/auto/gracias-alt", { state: props });
            }
            return volverADatos(mensajeDeError(bffError));
        }
    };

    /**
     * Camino BFF: una sola conexión SSE alimenta las cards por compañía a
     * medida que llegan los resultados. Si el stream se corta, se reconcilia
     * con el snapshot de la cotización.
     */
    const dispararCotizacionSse = () => {
        setCotizando(true);
        const fechaConsultaCotizaciones = new Date();
        let acumuladas: Cotizacion[] = [];
        const ctx = contextoPrecios();

        const volcar = (items: any[]) => {
            acumuladas = acumuladas.concat(items as Cotizacion[]);
            setCotizacionValues({
                ...useCotizacionStore.getState().cotizacionValues,
                fechaConsultaCotizaciones,
                cotizaciones: acumuladas,
            });
        };

        conexionSse.current = escucharPrecios(ramoBff, ctx, {
            onInicio: ({ sumaAsegurada, vigenciaHasta }) => {
                // La suma de la cotización llega con `started`: alimenta el
                // fallback de los planes que no traen la suya.
                if (sumaAsegurada) ctx.sumaAseguradaFallback = sumaAsegurada;
                if (vigenciaHasta) {
                    setCotizacionValues({
                        ...useCotizacionStore.getState().cotizacionValues,
                        vigenciaHasta,
                    });
                }
            },
            onCompania: (_codigo, items) => volcar(items),
            onCompaniaError: (codigo, code) => {
                // eslint-disable-next-line no-console
                console.warn(`[auto_via_bff] ${codigo} no cotizó: ${code}`);
            },
            onFin: () => setCotizando(false),
            onFalla: async (error) => {
                if (requiereVolverADatos(error)) {
                    setCotizando(false);
                    return volverADatos(mensajeDeError(error));
                }
                try {
                    const items = await cargarSnapshotPrecios(ramoBff, ctx);
                    if (items.length) volcar(items as any[]);
                } catch (errorSnapshot) {
                    // eslint-disable-next-line no-console
                    console.warn(
                        "[auto_via_bff] snapshot de precios:",
                        aBffError(errorSnapshot).code
                    );
                }
                setCotizando(false);
            },
        });
    };

    useEffect(() => {
        vaciarCotizaciones();
        //cotizacionValues.cotizaciones = [];
        if (cotizacionValues.parametrosIniciales) {
            if (!esVigenciaCotizacionesValida()) {
                setTimeout(() => {
                    setCargando(false);
                }, 10000);
                setCargando(true);
            }
            if (!cotizacionValues?.contactoId) {
                if (viaBff) {
                    crearContactoBff();
                    return;
                }
                const fetchData = async () => {
                    const response: any = await guardarContacto(
                        cotizacionValues?.parametrosIniciales.rubro,
                        cotizacionValues?.parametrosIniciales.origen,
                        cotizacionValues?.parametrosIniciales.tipoCotizador,
                        cotizacionValues?.landingUrl,
                        cotizacionValues?.referer,
                        cotizacionValues?.patente,
                        cotizacionValues?.marca?.value,
                        cotizacionValues?.modelo?.value,
                        cotizacionValues?.version?.value,
                        cotizacionValues?.año?.value,
                        cotizacionValues?.email,
                        cotizacionValues?.telefono?.prefijo,
                        cotizacionValues?.telefono?.numero,
                        cotizacionValues?.fechaNac?.dia +
                        "/" +
                        cotizacionValues?.fechaNac?.mes +
                        "/" +
                        cotizacionValues?.fechaNac?.año,
                        cotizacionValues?.genero?.value === "M" ? "Masculino" : "Femenino",
                        cotizacionValues?.provincia?.value,
                        cotizacionValues?.localidad?.value,
                        cotizacionValues?.nombre,
                        cotizacionValues?.apellido,
                        cotizacionValues?.cuandoContrata?.label,
                        cotizacionValues?.captchaToken
                    );
                    if (response.data) {
                        if (
                            response.data.api_status === 200 &&
                            response.data.api_data !== null
                        ) {
                            setCotizacionValues({
                                ...cotizacionValues,
                                contactoId: response.data.api_data.idContacto,
                                sumaAseguradaIA: response.data.api_data.sumaAseguradaIA,
                                token: response.data.api_data.token,
                            });
                        } else if (
                            response.data.api_data ===
                            "El Mail informado no es un mail válido"
                        ) {
                            compania
                                ? nav(
                                    "/auto/cotizacion/" +
                                    compania +
                                    "/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                                )
                                : nav(
                                    "/auto/cotizacion/email?error=Por favor, ingresá una dirección de correo electrónico válida"
                                );
                        } else if (response.data.api_data === "El Captcha no es válido") {
                            compania
                                ? nav(
                                    "/auto/cotizacion/" +
                                    compania +
                                    "/codigo-postal?error=El Captcha no es válido"
                                )
                                : nav(
                                    "/auto/cotizacion/codigo-postal?error=El Captcha no es válido"
                                );
                        } else if (response.data.api_data === "Origen Inválido") {
                            // El asesor vuelve a /auto/vendedor (US 23866); el cliente, al paso de patente.
                            nav(inicioCotizacion("auto", cotizacionValues.landingUrl, compania) + "?error=Orígen inválido");
                        } else if (
                            response.data.api_data === "El Teléfono informado no es válido"
                        ) {
                            compania
                                ? nav(
                                    "/auto/cotizacion/" +
                                    compania +
                                    "/telefono?error=Por favor, ingresá un n° de teléfono válido"
                                )
                                : nav(
                                    "/auto/cotizacion/telefono?error=Por favor, ingresá un n° de teléfono válido"
                                );
                        } else if (
                            response.data.api_data === "La localidad no es válida."
                        ) {
                            compania
                                ? nav(
                                    "/auto/cotizacion/" +
                                    compania +
                                    "/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                                )
                                : nav(
                                    "/auto/cotizacion/codigo-postal?error=Por favor, ingresá nuevamente la localidad"
                                );
                        } else if (
                            response.data.api_data.startsWith(
                                "*** Se recibió cotización BLOQUEADA"
                            )
                        ) {
                            var props = {
                                nombre:
                                    cotizacionValues.nombre + " " + cotizacionValues.apellido,
                                email: cotizacionValues.email!,
                                telefono:
                                    cotizacionValues.telefono?.prefijo +
                                    "" +
                                    cotizacionValues.telefono?.numero,
                                vehiculo:
                                    cotizacionValues.marca?.value +
                                    " " +
                                    cotizacionValues.version?.value +
                                    " " +
                                    cotizacionValues.año?.value,
                                aseguradora: "Sin seleccionar",
                                tipo: "emision",
                            };
                            compania
                                ? nav("/auto/gracias-alt/" + compania, { state: props })
                                : nav("/auto/gracias-alt", { state: props });
                        } else {
                            nav("/auto/error");
                        }
                    } else {
                        compania
                            ? nav(
                                "/auto/cotizacion/" +
                                compania +
                                "/codigo-postal?error=Error de conexion."
                            )
                            : nav(
                                "/auto/cotizacion/codigo-postal?error=Error de conexion."
                            );
                    }
                };
                fetchData();
            }
        } else {
            nav(inicioCotizacion("auto", cotizacionValues.landingUrl, compania));
        }
    }, []);

    useEffect(() => {
        if (cotizacionValues.contactoId) {
            dispararCotizacion();
        }
        return () => {
            source.cancel();
            conexionSse.current?.cancelar();
        };
    }, [cotizacionValues.contactoId]);

    // Venta presencial: si la cotización empezó en /auto/vendedor, se le avisa al BFF qué asesor
    // y en qué sucursal trajo el lead (ver useRegistroVendedor).
    useRegistroVendedor(
        {
            contactoId: cotizacionValues.contactoId,
            landingUrl: cotizacionValues.landingUrl,
            ventaPresencial: cotizacionValues.ventaPresencial,
        },
        origen,
        viaBff,
        configCargando
    );

    const esVigenciaCotizacionesValida = (): boolean => {
        if (
            cotizacionValues.cotizaciones &&
            cotizacionValues.cotizaciones.length > 0
        ) {
            // Camino BFF: la vigencia la fija el backend, no el "mismo día".
            if (cotizacionValues.vigenciaHasta) {
                const vence = Date.parse(cotizacionValues.vigenciaHasta);
                if (!Number.isNaN(vence)) return vence > Date.now();
            }
            const fechaEnSesion = new Date(
                cotizacionValues.fechaConsultaCotizaciones + ""
            );
            const fechaActual = new Date();
            if (
                fechaActual.getFullYear() !== fechaEnSesion?.getFullYear() ||
                fechaActual.getMonth() !== fechaEnSesion.getMonth() ||
                fechaActual.getDate() !== fechaEnSesion.getDate()
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    };

    const dispararCotizacion = async () => {
        if (esVigenciaCotizacionesValida()) return;

        if (viaBff) {
            dispararCotizacionSse();
            return;
        }

        setCotizando(true);
        let nuevasCotis: Cotizacion[] = [];
        try {
            const fechaConsultaCotizaciones = new Date();
            await Promise.all(
                cotizacionValues.parametrosIniciales.companias.map(
                    async (compania: any, index: number, array: []) => {
                        const results = await cotizarInterno(compania, index);
                        if (results && results.length > 0) {
                            nuevasCotis = nuevasCotis.concat(results);
                            setCotizacionValues({
                                ...cotizacionValues,
                                fechaConsultaCotizaciones,
                                cotizaciones: nuevasCotis,
                            });
                        }
                    }
                )
            );
        } catch (error) {
            setCotizacionValues({
                ...cotizacionValues,
                cotizaciones: [],
            });
        } finally {
            setCotizando(false);
        }
    };

    /*const fetchCotis = async (compania: any, index: number) => {
          return await cotizarInterno(compania, index);
      }*/

    const encontrarRuta = (compania?: string): string =>
        logoDeCompania(compania, envConf.pais);

    const irAInicio = (event: any) => {
        event.preventDefault();
        setCotizacionValues({
            ...cotizacionValues,
            contactoId: undefined,
        });
        if (cotizacionValues.patente) {
            nav(inicioCotizacion("auto", cotizacionValues.landingUrl, compania));
        } else {
            // nav("/auto/cotizacion/marca");
            compania
                ? nav("/auto/cotizacion/" + compania + "/marca")
                : nav("/auto/cotizacion/marca");
        }
    };

    const segLoadingComponent = useMemo(
        () => (
            <SegLoading
                loadingTitle="Cargando"
                product={
                    cotizacionValues?.marca?.label +
                    " " +
                    cotizacionValues?.version?.label
                }
                startText="¡Ya casi! Estamos buscando las coberturas ideales y los mejores descuentos para que ahorres al máximo en tu auto"
                middleText=""
                endText=""
                captions={[
                    {
                        value: "Gratuito",
                    },
                    {
                        value: "Online",
                    },
                    {
                        value: "Personalizado",
                    },
                ]}
                backgroundColor={origen !== "SEGURARSE" ? config.colors.primary : undefined}
                productTextColor={origen !== "SEGURARSE" ? config.colors.tertiary : undefined}
                dotsColors={origen !== "SEGURARSE" ? [config.colors.secondary, config.colors.tertiary, config.colors.accent] : undefined}
            />
        ),
        [cotizacionValues?.marca?.label, cotizacionValues?.version?.label]
    );
    return (
        <>
            <ModalPrecios cotizacionDesc={{ ...emisionValues.cotizacionDesc! }} />
            <AvisosEmbudo className="maxw-1170p mx-auto mt-3" />
            {cargando ? (
                segLoadingComponent
            ) : cotizacionValues.año?.value !== "0 Km" &&
                new Date().getFullYear() - parseInt(cotizacionValues.año?.value!) >=
                parseInt(envConf.anio_gracias! + "") ? (
                <GraciasAuto
                    nombre={cotizacionValues.nombre + " " + cotizacionValues.apellido}
                    email={cotizacionValues.email!}
                    telefono={
                        cotizacionValues.telefono?.prefijo +
                        "" +
                        cotizacionValues.telefono?.numero
                    }
                    vehiculo={
                        cotizacionValues.marca?.value +
                        " " +
                        cotizacionValues.version?.value +
                        " " +
                        cotizacionValues.año?.value
                    }
                    tipo="vehiculoantiguo"
                />
            ) : (
                <div>
                    <SegSvg />
                    <header className="site-header sticky-lg-top"
                        style={{ background: origen !== "SEGURARSE" ? config.colors.navbar : "#ffffff" }}>
                        <div className="container">
                            {
                                origen !== "SEGURARSE" ?
                                    <div className="row">
                                        <div className="col-md-6 offset-md-3 text-center d-flex justify-content-center gap-3">
                                            {" "}
                                            {/* Centra el contenido en la columna */}
                                            <SegHeaderLogo
                                                img={config.images.logo}
                                                alt="Logo Segurarse"
                                                width={window.innerWidth > 768 ? "130px" : "100px"}
                                                style={{ filter: "brightness(0) invert(1)" }}
                                            />
                                            <div style={{ height: "100%", width: "2px", backgroundColor: "#ffffff" }}></div>
                                            <SegHeaderLogo
                                                img={segurarse}
                                                alt="Logo Segurarse"
                                                width={window.innerWidth > 768 ? "140px" : "110px"}
                                                style={{ filter: "brightness(0) invert(1)" }}
                                            />
                                        </div>
                                    </div>
                                    :
                                    <div className="row">
                                        <div className="col-md-6 offset-md-3 text-center">
                                            {" "}
                                            {/* Centra el contenido en la columna */}
                                            <SegHeaderLogo
                                                img={segurarse}
                                                alt="Logo Segurarse"
                                                width="160px"
                                            />
                                        </div>
                                    </div>
                            }

                        </div>
                    </header>
                    <main className="sec-precios">
                        <div className="main-wrapper">
                            <div className="ac-desktop" style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}>
                                <div>
                                    <b>{"Vehículo cotizado > "}</b>
                                    <b>
                                        {cotizacionValues.marca?.value +
                                            " " +
                                            cotizacionValues.version?.value +
                                            " " +
                                            cotizacionValues.año?.value}{" "}
                                        |
                                    </b>{" "}
                                    Zona de guardado: <b>{cotizacionValues.localidad?.label}</b>{" "}
                                    GNC: <b>No</b>
                                    {/* Suma asegurada: <b>${Number.parseInt(cotizacionValues.sumaAseguradaIA || "").toLocaleString("es-AR")}</b> */}
                                </div>
                                <div>
                                    <a
                                        href="/#"
                                        onClick={(e) => irAInicio(e)}
                                        className="btn1 btn1-light"
                                    >
                                        Modificar datos
                                    </a>
                                </div>
                            </div>

                            <div className="ac-mobile d-lg-none">
                                <div className="wrapper">
                                    <a
                                        className={`trigger ${isCollapsed ? "collapsed" : ""}`}
                                        data-bs-toggle="collapse"
                                        href="#collapseExample"
                                        aria-controls="collapseExample"
                                        role="button"
                                        aria-expanded="false"
                                        onClick={toggleCollapse}
                                        style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}
                                    >
                                        <svg className="icon ico-car">
                                            <use xlinkHref="#ico-auto" />
                                        </svg>{" "}
                                        cotizado
                                        <svg className="icon ico-arrow">
                                            <use xlinkHref="#arrowright2" />
                                        </svg>
                                    </a>
                                    <div
                                        className={`collapse ${isCollapsed ? "" : "show"}`}
                                        id="collapseExample"
                                    >
                                        <div className="detail"
                                            style={origen !== "SEGURARSE" ? { background: config.colors.accent } : {}}
                                        >
                                            <p>
                                                <b>
                                                    {cotizacionValues.marca?.value +
                                                        " " +
                                                        cotizacionValues.version?.value +
                                                        " " +
                                                        cotizacionValues.año?.value}
                                                </b>
                                                <br />
                                                <b>{cotizacionValues.localidad?.label}</b> | GNC:{" "}
                                                <b>No</b>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ban"
                                style={origen !== "SEGURARSE" ? { background: config.colors.primary } : {}}>
                                <div style={{width: "100%", display: "flex", justifyContent: "center"}}>
                                    <div>
                                        <svg className="icon">
                                            <use xlinkHref="#moneyrecive" />
                                        </svg>
                                    </div>
                                    <div className="text-center">
                                        <b>Descuento online contratando ahora.</b>
                                        <br className="d-md-none" />
                                        <b>{envConf.pais === "UY" ?
                                            ""
                                            :
                                            " Válido con tarjeta de crédito (no prepaga)"}
                                        </b>
                                    </div>
                                </div>
                                {cotizando && (
                                    <div className="clearfix">
                                        <div className="spinner-border spinner-border-sm float-end"></div>
                                        <span style={{ marginRight: "5px" }} role="status">
                                            Seguimos cotizando...
                                        </span>
                                    </div>
                                )}
                            </div>
                            {window.innerWidth > 768 && (
                                <>
                                    <Slider
                                        pais={envConf.pais || "AR"}
                                        cotizando={cotizando}
                                        cotizaciones={cotizacionValues.cotizaciones || []}
                                        setDescripciones={handleSetCotizacionDesc}
                                    />
                                    <Grilla
                                        pais={envConf.pais || "AR"}
                                        cotizando={cotizando}
                                        cotizaciones={cotizacionValues.cotizaciones || []}
                                        setDescripciones={handleSetCotizacionDesc}
                                    />
                                </>
                            )}
                            <Cards
                                pais={envConf.pais || "AR"}
                                cotizando={cotizando}
                                cotizaciones={cotizacionValues.cotizaciones || []}
                                setDescripciones={handleSetCotizacionDesc}
                            />
                        </div>
                    </main >
                </div >
            )}
        </>
    );
};
